import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.css']
})
export class ErrorPageComponent implements OnInit {

  PrimaryMessage: string = "Something went wrong.";
  SecondaryMessage: string = "";
  unauthorized: boolean = true;

  constructor(private router: Router, private route: ActivatedRoute, private dataService: DataService) {
    if (this.router.url == '/unauthorized') {
      this.PrimaryMessage = "Unauthorized User";
      this.unauthorized = false;
    }
  }

  ngOnInit(): void {
    $(document).ready(function () {
      $('.userdetail').css('display', 'none');
      $('.loggoff').css('display', 'none');
      $('.wow fadeInLeft').css('display', 'none');
      $('.ipad_none').css('display', 'none');
      // var ele = document.getElementsByName("footer");
      // return ele[0].parentNode.removeChild(ele[0]);
    });
    // alert("error");
  }

  // redirectToPage(page: string) {
  //   this.router.navigate(['/login']);
  // }
  // redirectToPage(page: string) {
  //   let url = this.dataService.sso_url;
  //   window.location.href = url;
  // }

  redirectToPage(page: string) {
    if (this.dataService.is_sso == true) {
      //this.router.navigate(['/sso-logout']);
      // let url = this.dataService.sso_url;
      // window.location.href = url;
    }
    else {
      this.router.navigate(['/login']);
    }
  }
}
